module.exports = __webpack_public_path__ + "img/man_grey.a05b8f3d.svg";